/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React from 'react';
import { withConfigContext } from '../../../../../../../../../components/ConfigContext';
import { withTranslation } from 'react-i18next';
import { Button, Card, Col, Form, Input, Row, Space } from 'antd';
import styles from '../styles.module.css';

class GroupDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groupName: '',
      groupDescription: '',
      isformCompleted: false,
    };
  }

  handleChange = event => {
    const name = event.target.name;
    const value = event.target.value;
    const { groupName, groupDescription } = this.state;
    const isGroupNameEmpty = name === 'groupName' && !value;
    const isGroupDescriptionEmpty = name === 'groupDescription' && !value;
    const isformCompleted =
      groupName &&
      groupDescription &&
      !isGroupNameEmpty &&
      !isGroupDescriptionEmpty;
    this.setState({
      [name]: value,
      isformCompleted,
    });
  };

  onFinish = values => {
    this.props.onSubmit({
      groupName: values.GroupName,
      groupOwner: values.GroupOwner,
      groupDescription: values.GroupDescription,
    });
  };

  onFinishFailed = errorInfo => {};

  render() {
    const { t } = this.props;
    return (
      <div>
        <Form>
          <Card className={styles.cardContainer}>
            <Form
              name="basic"
              labelCol={{
                span: 4,
              }}
              wrapperCol={{
                span: 8,
              }}
              initialValues={{
                GroupName: '',
                GroupOwner: this.props.context.user,
                GroupDescription: '',
              }}
              onFinish={this.onFinish}
              onFieldsChange={this.onFinishFailed()}
              autoComplete="off"
            >
              <Form.Item
                label={t('label_group_owner')}
                name="GroupOwner"
                rules={[{}]}
              >
                <Input
                  placeholder={t('label_group_owner_placeHolder')}
                  readOnly
                />
              </Form.Item>

              <Form.Item
                label={t('label_group_name')}
                name="GroupName"
                rules={[{ required: true }]}
              >
                <Input
                  placeholder={t('label_group_name_placeHolder')}
                  name="groupName"
                  onChange={this.handleChange}
                />
              </Form.Item>

              <Form.Item
                label={t('label_groupDescription')}
                name="GroupDescription"
                rules={[{ required: true }]}
              >
                <Input
                  placeholder={t('label_group_description_placeHolder')}
                  name="groupDescription"
                  onChange={this.handleChange}
                />
              </Form.Item>

              <Form.Item
                wrapperCol={{
                  offset: 8,
                  span: 16,
                }}
              >
                <Row>
                  <Col lg={{ span: 10, offset: 18 }}>
                    <div className={styles.buttons}>
                      <Space>
                        <Button
                          htmlType="submit"
                          className={styles.btn1}
                          onClick={this.props.setPrevStep}
                        >
                          {t('label_back')}
                        </Button>

                        <Button
                          type="primary"
                          htmlType="submit"
                          className={styles.btn}
                          onClick={this.props.setNextStep}
                          disabled={!this.state.isformCompleted}
                        >
                          {t('label_continue')}
                        </Button>
                      </Space>
                    </div>
                  </Col>
                </Row>
              </Form.Item>
            </Form>
          </Card>
        </Form>
      </div>
    );
  }
}

export default withConfigContext(withTranslation()(GroupDetails));
